import { default as VARIABLES } from '../../themes/styles/variables'

export { VARIABLES }

export const ProgressBarStyle = {
  div: {
    padding: '32px 64px',
    background: 'white',
    borderRadius: '10px',
    position: 'relative',
  },
  label: {
    fontSize: '1.25rem',
    marginBottom: '16px',
  },
  container: {
    minWidth: '700px',
    height: '22px',
    background: '#eee',
    position: 'relative',
    overflow: 'hidden',
  },
  percent: {
    background: VARIABLES.COLORS.BLUE_1,
    position: 'absolute',
    left: '0',
    top: '0',
    height: '100%',
    borderRadius: '20px',
  },
  percentText: {
    float: 'right',
    fontSize: '0.85rem',
    marginRight: 5,
  },
}
